import { Severity } from '@kirin/api-client/contracts/shared/severity';

/**
 * Shared OSV presentation primitives (KIR-4190) — one `osv.dev` link format and
 * one severity palette, previously duplicated module-private in
 * `OsvVulnerabilityCell` (KIR-3805) and `AlertSourceDetails` (KIR-4070).
 */

/** Canonical advisory URL for an OSV/CVE/GHSA id. */
export function osvAdvisoryUrl(id: string): string {
  return `https://osv.dev/vulnerability/${encodeURIComponent(id)}`;
}

export const OSV_SEVERITY_CLASSES: Record<Severity, string> = {
  [Severity.Critical]:
    'bg-red-100 text-red-800 border-red-200 dark:bg-red-900/30 dark:text-red-300 dark:border-red-800',
  [Severity.High]:
    'bg-orange-100 text-orange-800 border-orange-200 dark:bg-orange-900/30 dark:text-orange-300 dark:border-orange-800',
  [Severity.Medium]:
    'bg-amber-100 text-amber-800 border-amber-200 dark:bg-amber-900/30 dark:text-amber-300 dark:border-amber-800',
  [Severity.Low]:
    'bg-blue-100 text-blue-800 border-blue-200 dark:bg-blue-900/30 dark:text-blue-300 dark:border-blue-800',
};

export const OSV_SEVERITY_LABEL: Record<Severity, string> = {
  [Severity.Critical]: 'Critical',
  [Severity.High]: 'High',
  [Severity.Medium]: 'Medium',
  [Severity.Low]: 'Low',
};

/** Chip text for a CVSS band + score, e.g. `High · 7.5`. */
export function formatCvssChipText(
  level: Severity,
  score: number | null | undefined
): string {
  const label = OSV_SEVERITY_LABEL[level];
  return score != null ? `${label} · ${score.toFixed(1)}` : label;
}
